<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav sidebar-fill" fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">
    <mat-toolbar>
      <a [routerLink]="['/']">
        <img class="sidebarImage" src="../../assets/images/brand/salesmail_logo_reverse_brand.svg" height="51px" width="160px" />
      </a>
    </mat-toolbar>
    @if (!isLoading()) {
      <mat-nav-list>
        @for (item of navItems; track $index) {
          <a mat-list-item (click)="navigate(item)"
            [class.nav-item-disabled]="smActionsDisabled()"
            [attr.aria-disabled]="smActionsDisabled() ? 'true' : null"
            [attr.tabindex]="smActionsDisabled() ? -1 : null">
            <fa-icon icon="{{ item.icon }}" class="white mr10"></fa-icon>
            <span class="white">{{ item.name }}</span>
          </a>
        }
        <a mat-list-item (click)="goToHelpCenter()" (click)="toggle()">
          <fa-icon mat-icon icon="medkit" class="white mr10"></fa-icon>
          <span class="white">Help Center</span>
        </a>
        <a mat-list-item (click)="goToSidekick()">
          <img class="sidekick-logo"
            src="../../assets/images/brand/sidekick_logo_dark_bkgd.png"
            alt="Sidekick" />
        </a>
      </mat-nav-list>
    } @else {  
      <div class="menu-skeleton-container">
        <div class="menu-skeleton-row table-skeleton-row-text"></div>
        <div class="menu-skeleton-row table-skeleton-row-text"></div>
        <div class="menu-skeleton-row table-skeleton-row-text"></div>
        <div class="menu-skeleton-row table-skeleton-row-text"></div>
        <div class="menu-skeleton-row table-skeleton-row-text"></div>
        <div class="menu-skeleton-row table-skeleton-row-text"></div>
        <div class="menu-skeleton-row table-skeleton-row-text"></div>
        <div class="menu-skeleton-row table-skeleton-row-text"></div>
        <div class="menu-skeleton-row table-skeleton-row-text"></div>
      </div>    
    }
    <div class="version">SalesMail v{{ appVersion }}</div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      @if (isHandset$ | async) {
        <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
      }
      @if ((isHandset$ | async) === true) {
        <img src="../../assets/images/brand/logo_circle_white.png" height="44px" width="44px" />
      }
      @if (currentClient && allClients && allClients.length > 1) {
        <div class="menu-button-container">
          <button mat-flat-button class="menu-button" [matMenuTriggerFor]="menu" aria-label="Toggle menu"
            [class.menu-button-disabled]="smActionsDisabled()"
            [disabled]="smActionsDisabled()">
            <div class="inner_menu_button_container">
              <div class="menu_button_left"></div>
              <div class="menu_button_center">
                {{ currentClient.client_name }}
              </div>
              <div class="menu_button_right">
                <mat-icon>expand_more</mat-icon>
              </div>
            </div>
          </button>
          <mat-menu #menu="matMenu" xPosition="before">
            @for (c of allClients; track c.id) {
              <button mat-menu-item (click)="updateCurrentclient(c)">
                {{ c.client_name }}
              </button>
            }
          </mat-menu>
        </div>
      }
      <div class="user_nav">
        <button mat-icon-button [matMenuTriggerFor]="userMenu" class="account_button">
          <mat-icon class="account_button_icon">account_circle</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <div class="user_nav_header">
            <div class="accout_header">
              Account
            </div>
            <div>{{username}}</div>
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item [routerLink]="smActionsDisabled() ? null : ['/my-account']"
            [disabled]="smActionsDisabled()" class="nav_menu_item_text_color">
            <mat-icon color="primary">check_box</mat-icon>
            My Account
          </button>
          @if(is_admin) {
            <button mat-menu-item [routerLink]="smActionsDisabled() ? null : ['/settings']"
              [disabled]="smActionsDisabled()" class="nav_menu_item_text_color">
              <mat-icon color="primary">settings</mat-icon>
              Settings
            </button>
          }
          <button mat-menu-item class="nav_menu_item_text_color" (click)="toggleDarkMode()">
            <mat-icon color="primary">{{!isDark() ? 'dark_mode' : 'light_mode'}}</mat-icon>
            Switch to {{!isDark() ? 'Dark' : 'Light'}} Mode
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="signOut()" class="nav_menu_item_text_color">
            <mat-icon color="primary">logout</mat-icon>
            Sign Out
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>